// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonShortFieldLabels = {
  code: "编号",
  identifier: "标识",
  name: "名称",
  description: "描述",
  createdBy: "创建人",
  createdAt: "创建时间",
  updatedBy: "修改人",
  updatedAt: "修改时间",
} as const;

export const commonShortNouns = {
  status: "状态",
  actions: "操作",
} as const;
